module.exports = __webpack_public_path__ + "static/media/hospital-cross.7f71537e.svg";